module.exports = "<div class=\"movie-list-container\">\r\n    <!--<cm-movie-card *ngFor=\"let movie of movies\" [movie]=\"movie\" (select)=\"onSelectMovie(movie, $event)\"></cm-movie-card>-->\r\n    <ng-content></ng-content>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/movies/movie-list/movie-list.component.html
// module id = ../../../../../src/app/movies/movie-list/movie-list.component.html
// module chunks = 4